import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const Topbar = ({ labelPagina, isFolder, onClickBackListFolder }) => {

	return (
		<div className="w100">
      <div className="margin">
        <div className="esterni">
          <div className="titolo">
            <h1>
              <span dangerouslySetInnerHTML={ {__html: labelPagina} } ></span>
              {isFolder ? 
                  <img src="/assets/media/return.png" loading="lazy" id="w-node-a876c42c-a290-8cf5-c375-8b2580240081-f503dc95" alt="" className="icon pointer return" onClick={() => onClickBackListFolder()}></img>
                  :
              ''
              }
            </h1>
          </div>
          <div className="destra">
            <div className="user-block">
              <a href="/modifica-profilo" className="w-inline-block"><img src="/assets/media/profile.svg" loading="lazy" alt="" className="image"/></a>
            </div>
          </div>
        </div>
      </div>
</div> 

	)
}

Topbar.protoTypes = {
	auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
	auth: state.auth
});

export default connect(mapStateToProps, {})(Topbar);